module.exports = __webpack_public_path__ + "img/IMG_1444_L_Wood.0e5d5ad0.jpg";